<template>
  <div v-if="items && items.length > 0" class="bg-gray-300">
    <UContainer :class="sectionContainer.internal">
      <TTitle tag="h2" size="3xl">
        {{ t('views.cottage-list.closeCottages.title', { title }) }}</TTitle
      >
      <div v-for="item in items" :key="item.title" class="my-8">
        <TText v-if="item.url" tag="h3" variant="semibold">
          <a class="no-underline" :href="item.url">{{ item.title }}</a>
        </TText>
        <TText v-else tag="h3" variant="semibold">
          {{ item.title }}
        </TText>
        <TGrid v-if="item.seoEntities.length > 0" :gap-y="4">
          <UButton
            v-for="(link, index) in item.seoEntities"
            :key="index"
            variant="link"
            color="neutral"
            size="sm"
            :to="link.url"
            external
            class="col-span-12 md:col-span-3 no-underline"
            >{{ link.name }}</UButton
          >
        </TGrid>
      </div>
    </UContainer>
  </div>
</template>
<script setup lang="ts">
import { sectionContainer } from '~~/modules/design-system/utils/nuxt-ui-config/components/container'

defineProps<{
  items: Array<{
    title: string
    url: string | null
    seoEntities: Array<{
      name: string
      url: string
    }>
  }>
  title: string
}>()
</script>
